import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconBundleBlueprint } from '@backstage/plugin-app-react';
import {
  schibstedLightThemeExtension,
  schibstedDarkThemeExtension,
} from './themes';
import {
  analyticsApi,
  scmIntegrationsApi,
  ghecAuthApi,
  scmAuthApi,
  ragAiApi,
  entityPreviewApi,
} from './apis';
import { signInPage } from './signInPage';
import { SidebarContent } from './sidebar';
import { restrictedTemplateTagsWrapper } from './restrictedTemplateTags';
import AlarmIcon from '@mui/icons-material/Alarm';

const customIcons = IconBundleBlueprint.make({
  name: 'custom-icons',
  params: {
    icons: {
      alert: AlarmIcon,
    },
  },
});

export const appExtensionsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    schibstedLightThemeExtension,
    schibstedDarkThemeExtension,
    analyticsApi,
    scmIntegrationsApi,
    ghecAuthApi,
    scmAuthApi,
    ragAiApi,
    entityPreviewApi,
    signInPage,
    customIcons,
    SidebarContent,
    restrictedTemplateTagsWrapper,
  ],
});
